import {WinPresentationController} from "../WinPresentationController";
import {TheRave} from "../../TheRave";
import {TimelineMax, TimelineLite} from "gsap";
import {TheRaveSymbol} from "../../symbol/TheRaveSymbol";
import {TheRaveSymbolState} from "../../symbol/TheRaveSymbolConfig";
import {TheRaveWildSymbol} from "../../symbol/TheRaveWildSymbol";
import {TheRaveSound} from "../../sound/TheRaveSound";


export class DoubleXways extends WinPresentationController {

    private _animations: TimelineLite[] = [];
    private _playedSkipped:boolean = false;

    constructor() {
        super("DoubleXways", true);
    }

    protected async createWinAnimation(): Promise<void> {

        const colIndexes: number [] = [];
        const symbolTotalSizes: number [] = [];

        const symbolSizes: number[][] = TheRave.model.parsedGameData.symbolSizes;

        (TheRave.model.parsedGameData.doDoubleXways || []).forEach((bool, index) => {
           if(bool) {
                colIndexes.push(index);
                // accumulate for full wild
                symbolTotalSizes.push(symbolSizes[index].reduce<number>((accumulator, current) => {
                    return accumulator + current;
                }, 0))

           }
        });

        this._animations = TheRave.xwaysEqView.getFullDoubleXwAnimList(colIndexes, symbolTotalSizes);
        (TheRave.model.parsedGameData.doDoubleXways || []).forEach((bool, index) => {
            if(bool) {
                // Switch symbol on reel to full wild symbol, hide other symbols
                const toFwAnimation: TimelineLite = new TimelineLite();
                const currentSymbol: TheRaveSymbol = TheRave.reels[index].getSymbol(1, true),
                    newSymbol: TheRaveSymbol = TheRave.reels[index].createSymbol("W", index, TheRaveSymbolState.NORMAL, currentSymbol.symbolHeight, true);

                //toFwAnimation.add(currentSymbol.playHighLight());
                //toFwAnimation.add(currentSymbol.playHighLight());
                //toFwAnimation.add(currentSymbol.playHighLight());
                //console.log("SWITCHING SYMBOL ON REEL: " + index);
                (<TheRaveWildSymbol>newSymbol)!.curMpValue = (symbolSizes[index].reduce<number>((accumulator, current) => {
                    return accumulator + current;
                }, 0));

                toFwAnimation.add([
                    //newSymbol.playLanding(),
                    () => {
                        this._playedSkipped = false;
                        TheRave.xwaysEqView.skipped = false;
                        TheRave.xwaysEqView.stackedSoundPlayed = false;
                        newSymbol.position.set(2, 1);
                        TheRave.XWaysController.updateFullWildPosition(index);
                       //debugger;

                        (<TheRaveWildSymbol>newSymbol)!.showMultiplier(symbolSizes[index].reduce<number>((accumulator, current) => {
                            return accumulator + current;
                        }, 0));

                        if(!TheRave.xwaysEqView.stackedStartPlayed) {
                            TheRaveSound.playSoundEffect("wildStackedStart");
                            //console.log("Play sound, index: " + index);
                            TheRave.xwaysEqView.stackedStartPlayed = true;
                        }
                    }]);
                toFwAnimation.add(() => TheRave.reels[index].removeOldSymbolOnFullWild(newSymbol, currentSymbol, 1), "+=0.633")



                this._animations.push(toFwAnimation);
            }
        });
        //this._animations = xWaysAnimations.concat(this._animations);

        await Promise.resolve(new TimelineLite().add(this._animations, "+=0.2"));
    }

    protected hasWin(): boolean {
        const doDoubleXways:boolean [] = TheRave.model.parsedGameData.doDoubleXways || [false, false, false, false, false];


        return (doDoubleXways[0] || doDoubleXways[1] || doDoubleXways[2] || doDoubleXways[3] || doDoubleXways[4]);
    }

    public skip(): void {
        this._animations.forEach(animation => {
            animation.timeScale(2);
        });

        if(!this._playedSkipped) {
            TheRaveSound.soundPlayer.fadeTrack({
                name: "wildStackedExpand",
                to: 0,
                duration: 0.5
            })  // fadeEffect(name: string, volume: number, duration: number)
            TheRaveSound.playSoundEffect("wildStackedMultiplier");
            TheRave.xwaysEqView.skipped = true;
            this._playedSkipped = true;
        }
    }

}